import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { WindowState } from '@progress/kendo-angular-dialog';
import { FormGroup } from '@angular/forms';
import { AuthService } from '@app/core/services';
import { User } from '@app/core/models';


@Component({
  selector: 'config-window',
  template: ``,
  styles: [``],
  //providers:  [ DatasourceService, AlertService ]
})
export class ConfigWindowComponent implements OnInit {

  //Inputs

  @Input() opened = false;  

  //Variables
  
  protected currentUser: User;
  
  protected windowState: WindowState = 'default';

  protected form: FormGroup = null;  

  //Eventos

  @Output() config: EventEmitter<{dataItem:any}> = new EventEmitter();    

  //Métodos

  constructor(protected authService: AuthService) {    

    this.authService.currentUser.subscribe(x => this.currentUser = x);

  }

  protected getFormGroup(user: User, dataItem?: any): FormGroup {

    return new FormGroup({});

  };

  protected getData(formGroup: FormGroup): Object {

    return formGroup.value;

  };  

  public open(dataItem: any): void {

    this.opened = true;
    this.form = this.getFormGroup(this.currentUser, dataItem)
            
  }

  public onSuccesfull(): void {
    
    let data = this.getData(this.form);
    console.log('data', data)

    this.config.emit({dataItem: data});
    this.opened = false;

  }

  get f() { 
    
    return this.form.controls; 
  
  }

  public onClose(): void {

    this.opened = false;    

  }

  public onCancel(): void {

    this.opened = false;    

  }

  ngOnInit() {

    this.form = this.getFormGroup(this.currentUser);
    
  }

}
